import {isNumber, isNaN} from "lodash"

export let NumberHelper = {
  isInteger(val): boolean {
    return this.toIntOrNull(val) !== null
  },
  toIntOrNull(val): number {
    const int = parseInt(val, 10);
    if (!this.isPresent(int)) {
      return null;
    }
    return int;
  },
  anyIntegers(vals: any[]): boolean {
    return vals.some((val) => this.isInteger(val));
  },
  numberToCurrency(locales: string, currency: string, num: number) {
    return new Intl.NumberFormat(locales, { style: 'currency', currency: currency }).format(num)
  },
  clamp(val: number, minValue: number, maxValue: number): number {
    return Math.max(minValue, Math.min(val, maxValue))
  },
  snap(val: number, unitSize: number): number {
    return Math.round(val / unitSize) * unitSize
  },
  isNumber(val): val is number {
    return isNumber(val) && !isNaN(val)
  },
  isPresent(val): boolean {
    return this.isNumber(val)
  },
  ordinalize(val): string {
    let x = val % 10,
      y = val % 100;
    if (x === 1 && y !== 11) {
      return val + "st";
    }
    if (x === 2 && y !== 12) {
      return val + "nd";
    }
    if (x === 3 && y !== 13) {
      return val + "rd";
    }
    return val + "th";
  },
  toDelimited(val: string | number, {fractionDigits}: {fractionDigits?: number} = {}): string {
    fractionDigits = fractionDigits ?? 2
    if (typeof val === 'string') {
      val = val.includes('.') ? parseFloat(val) : parseInt(val, 10)
    }
    return new Intl.NumberFormat("en-US", {
      style: 'decimal',
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    }).format(val)
  },
  toPercent(val: string | number, {fractionDigits}: {fractionDigits?: number} = {}): string {
    fractionDigits = fractionDigits ?? 2
    if (typeof val === 'string') {
      val = val.includes('.') ? parseFloat(val) : parseInt(val, 10)
    }
    return new Intl.NumberFormat("en-US", {
      style: 'percent',
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    }).format(val)
  },
};
